import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { NotificationService, DialogService, UtilService } from '../../shared/index';
import { Router, ActivatedRoute, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { MomentService } from '../../shared/moment/moment.service';
import { EventsService } from '../shared/events.service';
import { EventEdit } from '../shared/event-edit.model';
import { RegistrationManagementComponent } from '../registration/management/registration-management.component';
import { AttendeeManagementComponent } from '../attendee/management/attendee-management.component';
import { TabsComponent, TabComponent } from '../../shared/widgets/tabs/index';
import { EventDashboardComponent } from '../dashboard/event-dashboard.component';
import { AuthService } from '../../shared/auth/auth.service';
import { UserService } from '../../users/shared/user.service';
import { TranslationService } from '../../shared/translation/translation.service';
import {
  WlEventsToolbarBroadcastService,
  WlEventsToolbarEventTypeEnum,
} from '../../shared/container/toolbars/module/events/broadcast/index';
import { IWlComponentCanDeactivateRoute } from '../../shared/route/index';
import { FeatureService } from '../../shared/feature/feature.service';
import { FeatureNameEnum } from '../../shared/feature/feature-name.enum';
import { EventTabsEnum } from '../shared/event-tabs.enum';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/config/shared/config.service';

@Component({
  selector: 'wl-event-settings',
  templateUrl: 'event-settings.component.html',
  styleUrls: ['event-settings.component.css'],
  providers: [EventsService, UserService],
    standalone: false
})
export class EventSettingsComponent implements OnInit, AfterViewInit, OnDestroy, IWlComponentCanDeactivateRoute {
  @ViewChild('registrationManagement', { static: false }) registrationManagement: RegistrationManagementComponent;
  @ViewChild('registrationstab', { static: false }) registrationsTab: TabComponent;
  @ViewChild('attendeestab', { static: false }) attendeesTab: TabComponent;
  @ViewChild('tabsContainer', { static: false }) public _tabsContainer: TabsComponent;
  @ViewChild('generalSettingsTab', { static: false }) public _generalSettingsTab: TabComponent;
  @ViewChild('eventDashboardCtrl', { static: false }) public _eventDashboardCtrl: EventDashboardComponent;
  @ViewChild('attendeeManagement', { static: false }) attendeeManagement: AttendeeManagementComponent;
  @ViewChild('eventItemsTab', { static: false }) eventItemsTab: TabComponent;
  @ViewChild('eventSettingsTab', { static: false }) eventSettingsTab: TabComponent;

  private _momentService: MomentService;
  public eventId: number;
  public event: EventEdit;
  public isSaving: boolean;
  public isLoading: boolean;
  public userAccessLevel: number;
  public hasEventBenefits: boolean;
  public showModal = false;
  public tenantHttpsUrl: string = '';
  public _subscriptions: Array<Subscription> = [];

  /**
   * used for usaved changes when navigating away
   */
  public _navigateAwayDeferred: { allowNavigate(): void; cancelNavigate(): void } = null;

  /**
   * the event as it is when loaded or saved. unedited. use for comparison to a changed event.
   */
  public _unchangedEvent: EventEdit;

  /**
   * construct
   * @param _route
   * @param _eventsService
   * @param _dialogService
   * @param _router
   * @param _notificationService
   * @param _eventsToolbarBroadcastService
   * @paran _featureService
   */
  public constructor(
    public _route: ActivatedRoute,
    public _eventsService: EventsService,
    public _dialogService: DialogService,
    public _router: Router,
    public _notificationService: NotificationService,
    public _userService: UserService,
    public _utilService: UtilService,
    public _translationService: TranslationService,
    public _authService: AuthService,
    public _eventsToolbarBroadcastService: WlEventsToolbarBroadcastService,
    public _featureService: FeatureService,
    momentService: MomentService,
    private _configService: ConfigService,
    private _title: Title
  ) {
    this.eventId = 0;
    this.event = new EventEdit();
    this.isSaving = false;
    this.isLoading = false;
    this.tenantHttpsUrl = this._authService.getTenantHttpsUrl();
    this.userAccessLevel = 1;

    this._momentService = momentService;
  }

  /**
   * init the component
   */
  async ngOnInit() {
    let v4Redirect = await this._configService.hasBetaFeatureEnabled('EventsV4');

    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;

      if (this.userAccessLevel == 0) {
        this._router.navigate(['access/denied']);
      }
    });
    this._featureService.has(FeatureNameEnum.BenefitManagement).then((data: boolean) => {
      this.hasEventBenefits = data;
    });
    //this._subscriptions.push(this._route.params
    //  .map(params => params['id'])
    this._subscriptions.push(
      this._route.paramMap.subscribe((params) => {
        this.eventId = parseInt(params.get('id'));
        this.loadEvent(this.eventId);

        this._route.url.subscribe((data: Array<UrlSegment>) => {
          let isRegistrationRoute: boolean = false;
          let isAttendeesRoute: boolean = false;
          for (let seg of data) {
            if (this._utilService.toLowerTrim(seg.path) == 'registrations') {
              if (v4Redirect) {
                this._router.navigate([`events-v4/${this.eventId}/registrations`]);
              }
              //set to registrations tab
              isRegistrationRoute = true;
              this.registrationsTab.selected = true;
            }
            if (this._utilService.toLowerTrim(seg.path) == 'pending' && isRegistrationRoute) {
              if (v4Redirect) {
                this._router.navigate([`events-v4/${this.eventId}/registrations/pending`]);
              }
              //filter for registrations with profileid 0
              this.registrationsTab.selected = true;
              this.registrationManagement.searchParams.AllWithProfileIdNotAssigned = true;
              //this.registrationManagement.search();
            }
            if (this._utilService.toLowerTrim(seg.path) == 'attendees') {
              if (v4Redirect) {
                this._router.navigate([`events-v4/${this.eventId}/attendees`]);
              }
              //set to attendees tab
              isAttendeesRoute = true;
              this.attendeesTab.selected = true;
            }
            if (this._utilService.toLowerTrim(seg.path) == 'settings') {
              if (v4Redirect) {
                this._router.navigate([`events-v4/${this.eventId}/settings`]);
              }
              this.eventSettingsTab.selected = true;
            }
          }
          if (v4Redirect && data.length == 2) {
            this._router.navigate([`events-v4/${this.eventId}`]);
          }
        });
      })
    );

    this._subscriptions.push(
      this._eventsToolbarBroadcastService.subscribe((toolbarEvent) => {
        // only interested in registration saved
        if (toolbarEvent.type == WlEventsToolbarEventTypeEnum.registrationSaved) this.handleRegistrationSaved();
      })
    );
  }

  /**
   * clean up
   */
  public ngOnDestroy(): void {
    // clean up subscriptions
    if (this._subscriptions) this._subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * after view init
   */
  public ngAfterViewInit() {
    this._route.url.subscribe((urlParts) => {
      if (urlParts.length == 3 && urlParts[2].path.toLowerCase() == 'settings')
        setTimeout(() => this._tabsContainer.select(this._generalSettingsTab));
    });

    this._subscriptions.push(
      this._route.queryParams.subscribe((params) => {
        if (params.tab) {
          switch (params.tab) {
            case EventTabsEnum.Registrations:
              this._tabsContainer.select(this.registrationsTab);
              break;
          }
        }
      })
    );
  }

  /**
   * load the event for the given Id and save it in this.event
   * @param eventId
   */
  public loadEvent = (eventId: number): Promise<void> => {
    this.isLoading = true;
    this._unchangedEvent = null;
    return this._eventsService.getEventEdit(eventId).then(
      (data: EventEdit) => {
        if (this._utilService.isNullOrUndefined(data)) {
          this.showEventDoesntExistMessage();
        } else if (this._utilService.isNullOrLessThanOrEqualToZero(data.EventId)) {
          this.showEventDoesntExistMessage();
        } else {
          this.event = data;
          this._title.setTitle(this.event.EventName);
          // save for comparison later
          setTimeout(() => (this._unchangedEvent = JSON.parse(JSON.stringify(this.event))), 3000);
        }

        setTimeout(() => {
          this._eventDashboardCtrl.refresh();
          // just reset the search form. registration search is kicked off in the ID subscription.
          this.registrationManagement.resetSearchForm();
          this.attendeeManagement.resetAndSearch();
        });

        this.isLoading = false;
        return Promise.resolve();
      },
      (error: any) => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );
  };

  public showEventDoesntExistMessage = (): void => {
    this._translationService.get('events.settings.event-not-found-error-message').then((data: string) => {
      this._dialogService.error(data + ' (' + this.eventId.toString() + ')');
    });
  };

  public saveEvent = (): Promise<void> => {
    this.isSaving = true;
    return this._eventsService.updateEvent(this.event.EventId, this.event).then(
      () => {
        if (!this.event.UsePublicRegistrationEndDate) {
          this.event.PublicRegistrationEndDateUtc = new Date();
          this.event.PublicRegistrationEndDateUtc.setUTCHours(24, 0, 0, 0);
        }
        // save for comparison later
        this._unchangedEvent = JSON.parse(JSON.stringify(this.event));
        this._notificationService.success('Event Saved');
        this.isSaving = false;
      },
      (error: any) => {
        console.error(error);
        this.isSaving = false;
      }
    );
  };

  /**
   * return false to cancel route navigation.
   * if a promise<boolean> or observable<boolean> is returned, then they'll be awaited.
   *
   * @param routeSnapshot
   * @param stateSnapshot
   */
  canNavigateAway(
    routeSnapshot: ActivatedRouteSnapshot,
    stateSnapshot: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // can't save, don't need to ask
    if (this.userAccessLevel < 2) return true;

    // oh, it's not even dirty
    if (!this.isEventDirty()) return true;

    return new Promise<boolean>((resolveFn, rejectFn) => {
      this._navigateAwayDeferred = {
        allowNavigate: () => resolveFn(true),
        cancelNavigate: () => resolveFn(false),
      };

      this.showModal = true;
    });
  }

  /**
   * check if the event is changed.
   * Very expensive. Do not use often.
   */
  public isEventDirty(): boolean {
    if (this.isLoading) return false;

    if (this.event && (!this.event.Version || this.event.Version < 3)) return false;

    // compare literals
    let dirty: boolean = this.compareLiteralProperties(this._unchangedEvent, this.event);

    return dirty;
  }

  /**
   * compare litteral properties of 2 objects. won't compare arrays or other objects in the object.
   * Does compare Date objects... after all, this is an event manager.
   * @param a
   * @param b
   */
  public compareLiteralProperties(a: Object, b: Object): boolean {
    if (a === b || (a == null && b == null)) return true;

    if ((a == null && b != null) || (a != null && b == null)) return false;

    let dirty: boolean = false;

    // makes intellisense happy when using [key] subscript on strongly typed objects
    let aAny: any = <any>a;
    let bAny: any = <any>b;

    const dateDiffThreshhold: number = 1000;

    for (let key of Object.keys(a))
      try {
        let oftype: string = typeof aAny[key];

        // first check for any dates... because dates come over as strings?
        if (aAny[key] instanceof Date || bAny[key] instanceof Date)
          dirty =
            Math.abs(
              this._momentService
                .getMomentByObject(aAny[key])
                .startOf('day')
                .diff(this._momentService.getMomentByObject(bAny[key]).startOf('day'))
            ) > dateDiffThreshhold;
        // then only compare litteral properties
        else if (oftype == 'boolean' || oftype == 'number') dirty = bAny[key] != aAny[key];
        // strings are always special
        else if (oftype == 'string' && (!!aAny[key] || !!bAny[key]))
          dirty = (!aAny[key] && !!bAny[key]) || (!!aAny[key] && !bAny[key]) || aAny[key] != bAny[key];

        if (dirty) break;
      } catch (e) {}

    return dirty;
  }

  /**
   * when navigating away and the event is unsaved, they clicked "save" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalSaveClick(): void {
    this.saveEvent()
      .then(() => (this.showModal = false))
      .then(() => this._navigateAwayDeferred.allowNavigate());
  }

  /**
   * when navigating away and the event is unsaved, they clicked "cancel" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalCancelClick(): void {
    this.showModal = false;
    this._navigateAwayDeferred.cancelNavigate();
  }

  /**
   * when navigating away and the event is unsaved, they clicked "no" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalNoClick(): void {
    this.showModal = false;
    this._navigateAwayDeferred.allowNavigate();
  }

  /**
   * handles event item list changes from the event items control
   */
  public eventItemsListChanged(): void {
    this._eventDashboardCtrl.refresh();
  }

  /**
   * triggered when registration is saved
   */
  public handleRegistrationSaved() {
    this.registrationManagement.getRegistrations();
    this.attendeeManagement.getAttendees();
    this._eventDashboardCtrl.refresh();
  }

  /**
   * triggered by clicking new registration button
   */
  public handleNewRegistrationClick() {
    // request a new registration window
    this._eventsToolbarBroadcastService.broadcast({ type: WlEventsToolbarEventTypeEnum.newRegistration, data: this.eventId });
  }

  /**
   * Handles delete button click
   */
  public deleteClick(): void {
    this._eventsToolbarBroadcastService.broadcast({ type: WlEventsToolbarEventTypeEnum.deleteEvent, data: this.eventId });
  }

  /**
   * handles browser back and forward button navigation
   */
  @HostListener('window:beforeunload', ['$event']) public handleWindowBeforeUnload($event: any): boolean {
    return !this.isEventDirty();
  }
}
